<template>
  <page>
    <sidebar slot="sidebar" />
    <span slot="header">{{ component.name }}</span>
    <span slot="breadcrumbs">
      <b-breadcrumb :items="breadcrumbs"/>
    </span>

    <form-wrapper>

      <h4>Create Knowledge Check</h4>

      <b-form @submit="onSubmit">
        <b-form-group>
          <label for="instructions">Instructions</label>
          <wysiwyg :class="{ 'disabled' : saving }" v-model="model.instructions"/>
        </b-form-group>
        <b-form-group>
          <label for="questions">Number of Questions</label>
          <div class="text-muted">Select the number of questions that will be chosen from the question bank for each knowledge check</div>
          <b-form-input
            v-validate="'required'"
            id="questions"
            :disabled="saving"
            v-model="model.number_questions"
            class="col-sm-2"
            type="number"
            name="questions"
          />
        </b-form-group>
      </b-form>

      <b-form-group class="form-buttons">
        <b-button
          :disabled="saving"
          variant="secondary"
          @click="$router.push({name: 'admin-components'})"
        >Cancel</b-button>
        <b-button :disabled="disabled" type="submit" variant="primary" @click.stop="onSubmit">
          Create
          <span v-if="saving">
            <i class="fas fa-spinner fa-spin"></i>
          </span>
        </b-button>
      </b-form-group>
    </form-wrapper>

  </page>
</template>

<script>
import api from '@/api/knowledgechecks/knowledgecheck.js'
import { mapActions, mapState } from 'vuex'
import sidebar from '@/components/sidebar'
import page from '@/components/templates/page'
import formWrapper from '@/components/common/form/form-wrapper'

export default {
  components:{
    formWrapper,
    page,
    sidebar
  },
  data(){
    return {
      model: {
        number_questions:10
      },
      saving: false,
      fetching: false,
      isLoaded: false,
      breadcrumbs: [
        {
          text: 'Modules',
          to: {
            name: 'admin-modules'
          }
        },
        {
          text: 'Components',
          to: {
            name: 'admin-components'
          }
        },
        {
          text: 'Knowledge Check',
          active: true
        }
      ]
    }
  },
  computed: {
    ...mapState('tenants', {
      organization: 'current'
    }),
    ...mapState('components', {
      component: 'current'
    }),
    disabled(){
      return this.fetching || this.saving
    }
  },
  async mounted(){
    if(this.component.knowledgecheck_id){
      this.$router.push({name: 'admin-component-knowledgecheck', params: {component: this.component.id}})
    }
  },
  methods:{
    ...mapActions('components', {
      refresh: 'show'
    }),
    async onSubmit(){
      const payload = {
        tenantId: this.organization.id,
        componentId: this.component.id,
        data: this.model
      }

      this.saving = true
      await api.store(payload)
      await this.refresh({id:this.component.id})
      this.$router.push({name: 'admin-component-knowledgecheck', params: {component: this.component.id}})
      this.saving = false
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/knowledge-checks/components/create.vue